<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fCampaniaDctoCiclos"
        name="nomCampaniaDctoCiclos">
    <div class="grid ">
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'CAMPANIADCTOCICLO.LBL_NUMEROCICLO' | translate }}</label>
          <input type="text" pInputText id="numeroCiclo"
                 name="nomNumeroCiclo"
                 autocomplete="off"
                 formControlName="numeroCiclo"
                 numero-entero-reactive
                 [maxlength]="3"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.numeroCiclo.invalid">
            {{ 'CAMPANIADCTOCICLO.LBL_NUMEROCICLO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'CAMPANIADCTOCICLO.LBL_DESCUENTOTASA' | translate }}</label>
          <input type="text" pInputText id="descuentoTasa"
                 name="nomDescuentoTasa"
                 autocomplete="off"
                 formControlName="descuentoTasa"
                 porcentaje-reactive
                 [maxlength]="10"
                 [decimales]="6"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descuentoTasa.invalid">
            {{ 'CAMPANIADCTOCICLO.LBL_DESCUENTOTASA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3 text-center pt-4">
          <div *ngIf="!guardando">
            <button class="p-button-datatables" icon="fa fa-plus" label="{{ (campaniaDctoCiclos ? ('BTN_GUARDAR' | translate): ('BTN_AGREGAR'  | translate) ) }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
      </div>
      <div class="grid col-12 md:col-3 lg:col-3 text-center">
        <div class="col-12 md:col-12 lg:col-12 flex">
          <div class="div-form col-12 flex">
            <div class="col-12 md:col-6 lg:col-6">
              <p-radioButton name="indicadorSuma" label="{{ 'CAMPANIADCTOCICLO.LBL_RESTA' | translate}}" formControlName="indicadorSuma"
                             [value]="false"></p-radioButton>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <p-radioButton name="indicadorSuma" label="{{ 'CAMPANIADCTOCICLO.LBL_SUMA' | translate}}" formControlName="indicadorSuma"
                             [value]="true"></p-radioButton>
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorSuma.invalid">
              {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <br>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas"
               [value]="this.obtenerCampanias()" selectionMode="single" dataKey="idCampaniaDctoCiclos"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.numeroCiclo}}</td>
            <td>{{ row.indicadorSuma ? '+ ' + row.descuentoTasa : '- ' + row.descuentoTasa }}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editarCampaniaDctoCiclos(row)"></button>
                <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_ELIMINAR' | translate}}"
                        pButton (click)="eliminarCampaniaDctoCiclos(row)"></button>
              </div>
            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>


<p-confirmDialog #cd key="productos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

